export default "__VITE_ASSET__df3ae272__"